import React from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import OrganizationAddEditPage from 'components/pages/OrganizationAddEdit';
import pageTitles from 'utils/pageTitles';
import getRouteState from 'utils/getRouteState';
import { historyShape } from 'utils/shapes/router.shapes';

import { setTitle, setActiveMenuItem } from 'containers/store';

import {
  onSubmit,
  onCancel,
  loadPageData,
  onSurveyFetch,
  onSurveyClear,
} from './store';

class OrganizationAddEdit extends React.Component {
  static propTypes = {
    history: historyShape.isRequired,
    intl: intlShape.isRequired,
    isLoadedPage: PropTypes.bool.isRequired,
    loadPageData: PropTypes.func.isRequired,
    setActiveMenuItem: PropTypes.func.isRequired,
    setTitle: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    organizationId: PropTypes.number,
  };

  static defaultProps = {
    organizationId: null,
  };

  componentDidMount() {
    this.props.setTitle(this.props.intl.formatMessage(pageTitles.organizations));
    this.props.setActiveMenuItem('organizations');
    const routeState = getRouteState(this.props.history);
    this.props.loadPageData(routeState);
  }

  render() {
    return this.props.isLoadedPage ? (
      <OrganizationAddEditPage
        {...this.props}
      />
    ) : null;
  }
}

const mapDispatchToProps = {
  setTitle,
  onSubmit,
  onCancel,
  loadPageData,
  setActiveMenuItem,
  onSurveyFetch,
  onSurveyClear,
};

const mapStateToProps = (state) => ({
  ...state.OrganizationAddEdit,
});

export default (
  connect(mapStateToProps, mapDispatchToProps)(injectIntl(withRouter(OrganizationAddEdit)))
);
